import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const verticalScrollColumnsSelector = `.${manifest.blockJsClass}`;
	const verticalScrollColumnsItems = document.querySelectorAll(verticalScrollColumnsSelector);

	if (!verticalScrollColumnsItems?.length) {
		return;
	}

	const { VerticalScrollColumnsAnimation } = await import('./vertical-scroll-columns');

	verticalScrollColumnsItems.forEach((item) => {
		new VerticalScrollColumnsAnimation({
			container: item,
			firstColumn: item.querySelector(`${verticalScrollColumnsSelector}-column:first-child`),
			secondColumn: item.querySelector(`${verticalScrollColumnsSelector}-column:nth-child(2)`),
			thirdColumn: item.querySelector(`${verticalScrollColumnsSelector}-column:nth-child(3)`),
		}).init();
	});
});
